import Block from "base/Block";
import { initVideoGalleryPopup } from 'utils/videoGalleryPopup';
import { initVideoPopup } from 'utils/videoPopup';

class DoctorVideo extends Block {
	static get blockName() {
		return 'b-doctor-video';
	}

	onInit() {
		const iconVideo = this.el.querySelector(`.${DoctorVideo.blockName}__video-icon`);
		if (!iconVideo) return;
		
		const videoCollection = iconVideo.dataset.videoCollection;

		if(videoCollection) {
			initVideoGalleryPopup(DoctorVideo.blockName);
		} else if(iconVideo.dataset.videos) {
			initVideoPopup(DoctorVideo.blockName);
		}	
	}
}

Block.register(DoctorVideo);

export default DoctorVideo;